import { CheckboxField, FormDrawer, FormDrawerContent, Id } from "@dgs/core";
import { addMonths, format } from "date-fns";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { BaseApplicationDataFields } from "../../../../applications/BaseApplicationDataFields";
import { useBaseApplicationFormValidate } from "../../../../applications/baseApplicationFormValidate";
import { useCreateApplication } from "../../../../events/eventDetails/applications/create/useCreateApplication";
import { ParticipantManagementApplicationFormValues } from "../../../../shared/types/application";

interface Props {
	open: boolean;
	onClose: () => void;
	eventId: Id;
}

const formValues: ParticipantManagementApplicationFormValues = {
	setupDate: format(new Date(), "yyyy-MM-dd"),
	deletionDate: format(addMonths(new Date(), 3), "yyyy-MM-dd"),
	subdomain: "",
	projectNumber: "",
	configuration: {
		enableCheckInApp: false,
	},
};

export const CreateParticipantManagementApplicationDrawer: FC<Props> = ({ eventId, ...props }) => {
	const { t } = useTranslation();
	const { createParticipantManagementApplication } = useCreateApplication(eventId);
	const validate = useBaseApplicationFormValidate();

	return (
		<FormDrawer
			{...props}
			title={t("Create Participant Management")}
			validate={validate}
			onSubmit={createParticipantManagementApplication}
			initialValues={formValues}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<BaseApplicationDataFields />
					<CheckboxField label={t("Enable check in app")} name="configuration.enableCheckInApp" />
				</FormDrawerContent>
			)}
		/>
	);
};
